import { useQuery } from '@tanstack/vue-query'
import { usePitcherApi } from '@sdk/main'
import type { Ref } from 'vue'
import { unref } from 'vue'

export const useFetchUsers = (params: Ref<any>, options?: { enabled?: boolean }) =>
  useQuery(['users', unref(params)?.search], () => usePitcherApi().getUsers(unref(params)), {
    keepPreviousData: true,
    ...options,
  })
